import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { EditActionContext } from "./EditActionContext";

function useStore(modelConfig: any) {
  const { element, setBackendFormErrors, setLoading } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    setLoading(true);
    store(modelConfig.endpoint, element)
      .then((response: any) => {
        setBackendFormErrors({});
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useStore;
